// src/components/MainContent.js

import React from 'react';
import HomePage from '../pages/HomePage';
import AISearchPage from '../pages/AISearchPage';
import ClientManagementPage from '../pages/ClientManagementPage';
import WikiPage from '../pages/WikiPage';
import PasswordsPage from '../pages/PasswordsPage';
import ServiceValuesPage from '../pages/ServiceValuesPage';
import ManageAccessPage from '../pages/ManageAccessPage';
import TicketsPage from '../pages/TicketsPage';
import AcessoRemotoPage from '../pages/AcessoRemotoPage'; // NOVO IMPORT

// Novos imports para as páginas de gestão de chamados

import ManageTicketInfoPage from '../pages/ManageTicketInfoPage';
import TechnicalReportsPage from '../pages/TechnicalReportsPage';
import AssetManagementPage from '../pages/AssetManagementPage';
import AvisosPage from '../pages/AvisosPage';
import ContractsPage from '../pages/ContractsPage';
import FinanceiroPage from '../pages/FinanceiroPage';

export default function MainContent({ currentPage, onOpenSidebar, userId, userEmail, userPermissions, allowedCompanies, loadingPermissions, navigateTo, userUiItems, isSidebarPinned, navTrigger }) {
    if (loadingPermissions) {
        return (
            <main className={`flex-1 p-4 sm:p-6 md:p-8 overflow-y-auto flex items-center justify-center transition-all duration-300 ${isSidebarPinned ? 'lg:pl-[280px]' : 'lg:pl-[100px]'}`}>
                <p className="text-slate-400">A carregar permissões...</p>
            </main>
        );
    }
    
    const permissionLevel = userPermissions[currentPage];
    
    const renderPage = () => {
        switch (currentPage) {
            case 'home':
                return <HomePage permissionLevel={permissionLevel} navigateTo={navigateTo} uiItems={userUiItems['home']} />;
            case 'ai-search':
                return <AISearchPage permissionLevel={permissionLevel} navigateTo={navigateTo} />;
            case 'client-contracts':
                return <ClientManagementPage key="contracts" pageTitle="Clientes Contrato" collectionName="clients" userId={userId} permissionLevel={permissionLevel} allowedCompanies={allowedCompanies} uiItems={userUiItems['client-contracts']} />;
            case 'client-one-off':
                return <ClientManagementPage key="one-off" pageTitle="Clientes Avulsos" collectionName="clients-avulsos" userId={userId} permissionLevel={permissionLevel} allowedCompanies={allowedCompanies} uiItems={userUiItems['client-one-off']} />;
            case 'wiki':
                return <WikiPage userId={userId} permissionLevel={permissionLevel} uiItems={userUiItems['wiki']} />;
            case 'passwords':
                return <PasswordsPage userId={userId} permissionLevel={permissionLevel} uiItems={userUiItems['passwords']} />;
            case 'acesso-remoto': // NOVA ROTA ATIVADA
                return <AcessoRemotoPage permissionLevel={permissionLevel} />;
            case 'manage-access':
                return <ManageAccessPage userId={userId} />;
            case 'tickets':
                return <TicketsPage permissionLevel={permissionLevel} navigateTo={navigateTo} allowedCompanies={allowedCompanies} uiItems={userUiItems['tickets']} navTrigger={navTrigger} />;
            
            // Rotas para gestão de chamados

            case 'manage-ticket-info':
                return <ManageTicketInfoPage permissionLevel={permissionLevel} navigateTo={navigateTo} />;
            case 'service-values':
                return <ServiceValuesPage permissionLevel={permissionLevel} />;
            case 'technical-reports':
                return <TechnicalReportsPage permissionLevel={permissionLevel} allowedCompanies={allowedCompanies} uiItems={userUiItems['technical-reports']} />;
            case 'asset-management':
                return <AssetManagementPage permissionLevel={permissionLevel} allowedCompanies={allowedCompanies} uiItems={userUiItems['asset-management']} />;
            case 'avisos':
                return <AvisosPage permissionLevel={permissionLevel} />;
            case 'financeiro':
                return <FinanceiroPage permissionLevel={permissionLevel} allowedCompanies={allowedCompanies} uiItems={userUiItems['financeiro']} navigateTo={navigateTo} canOpenTickets={!!userPermissions['tickets'] && userPermissions['tickets'] !== 'none'} />;
            case 'contracts':
                return <ContractsPage permissionLevel={permissionLevel} allowedCompanies={allowedCompanies} userId={userId} userEmail={userEmail} uiItems={userUiItems['contracts']} />;
                
            default:
                return <HomePage />;
        }
    };

    return (
        <main className={`flex-1 overflow-y-auto flex flex-col min-h-0 min-w-0 transition-all duration-300 ${isSidebarPinned ? 'lg:pl-[280px]' : 'lg:pl-[100px]'}`}>
            <button onClick={onOpenSidebar} className="lg:hidden m-4 text-slate-400 hover:text-white print:hidden shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
            </button>
            <div className="flex-1 min-h-0 min-w-0 flex flex-col">
                {renderPage()}
            </div>
        </main>
    );
}